import {
  Component,
  HostListener,
  OnInit,
  ViewChild,
  ElementRef,
  TemplateRef,
} from "@angular/core";
import { Subject } from "rxjs";
import { AppMemoryService } from "./../../core/app-memory.service";
import { DatePipe } from "@angular/common";
import { GetService } from "../../core/get.service";
import { Horse } from "../../core/classes/horse";
import { Farm } from "../../core/classes/farm";
import { NotificationsService } from "angular2-notifications";
import { Router, ActivatedRoute } from "@angular/router";
import {
  Administer,
  Treatment,
  TreatmentAdminister,
} from "../../core/classes/treatment";
import { Vaccination } from "app/core/classes/vaccination";
import { Note } from "../../core/classes/note";
import { environment } from "../../../environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { BillingService } from "app/core/billing.service";
import { UKRegions, usaRegionBC2023 } from "app/models/Regions";
import { NoteType } from "../../core/types/note-type";
import { usaRegionPC, usaRegionPK } from "../../models/Regions";
import { RouteTypes } from "app/core/types/route-types";
import { CurrentCountryTypes } from "app/core/types/country-type";
import { AppStorageType } from "app/models/AppStorageType";
import { HttpClient } from "@angular/common/http";

declare const ImageCompressor: any;

@Component({
  selector: "app-horses",
  templateUrl: "./horses.component.html",
  styleUrls: ["./horses.component.less"],
})
export class HorsesComponent implements OnInit {
  public allSelected: Boolean = false;
  UKRegions = UKRegions;

  @HostListener("document:scroll", ["$event"])
  onWindowScroll() {
    if (
      $(window).scrollTop() >=
      $(document).height() - $(window).height() - 100
    ) {
      this.addNewData(this.horses);
    }
  }
  @ViewChild("imageLoader") public imageLoader: any;

  @ViewChild("farmsSelector") public farmsSelector: any;

  @ViewChild("updateFarmForm") public updateFarmForm: any;

  @ViewChild("createHorseForm") public createHorseForm: any;

  @ViewChild("newMicrochipNumber") public newMicrochipNumber: any;

  @ViewChild("createTreatmentForm") public createTreatmentForm: any;

  @ViewChild("imageLoader22") public imageLoader22: any;

  @ViewChild("imageLoader23") public imageLoader23: any;

  @ViewChild("noteDescr") public noteDescr: any;

  @ViewChild("newVaccinationName") public newVaccinationName: any;

  public isTrial = false;

  public maxImgCount = environment.maxImgCount;
  public maxImgSize = environment.maxImgSize;
  public showInTheFoodChainToggle = environment.showInTheFoodChainToggle;

  public _searchStream = new Subject<any>();

  public horses: Horses;

  public farms: Farms | any;
  public farm: Farm;

  public isYardPage = false;
  public yard_id = null;
  public doUnvaccinateGetApi = true;
  public pagination = {
    inProgress: false as boolean,
    nextPage: "" as string,
  };

  public serverError = null;
  public serverErrorValidate = null;
  public isRequestInProgress = false;

  public newHorse = new Horse();
  public updateFarm = new Farm();

  public countries: any[];
  public selectedCountry: any;
  public regions: any[];
  public selectedRegion: any;
  public showRegionsSelect: boolean = environment.showRegionsSelect;

  public newTreatment = new Treatment();
  public newVaccination = new Vaccination();
  public newNote = new Note();

  public invalidVaccinationForm = false;
  public invalidTreatmentForm = false;

  public dateRangeErrorMessage: { from?: string; due?: string; date?: string } =
    {} as { from?: string; due?: string; date?: string };
  public dateRangeTreatmentErrorMessage: {
    from?: string;
    due?: string;
    date?: string;
  } = {} as { from?: string; due?: string; date?: string };

  public datePicker = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 40)),
    maxDate: new Date() as Date,
    currentDate: new Date() as Date,
    currentDate_input:
      "" /*this.datePipe.transform(new Date(), environment.dateFormat)*/,
    isActive: false as boolean,
  };

  public loadSuggestion: boolean;

  public datePicker2 = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 40)),
    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 40)),
    currentDate: new Date(new Date().setDate(new Date().getDate())),
    currentDate_input:
      /*this.datePipe.transform(new Date(), environment.dateFormat)*/ "",
    isActive: false as boolean,
  };

  public datePicker3 = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 3)),
    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 3)),
    currentDate: new Date() as Date,
    currentDate_input:
      "" /*this.datePipe.transform(new Date(), environment.dateFormat)*/,
    isActive: false as boolean,
  };

  public datePicker4 = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 40)),
    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 40)),
    currentDate: new Date(new Date().setDate(new Date().getDate())),
    currentDate_input:
      /*this.datePipe.transform(new Date(), environment.dateFormat)*/ "",
    isActive: false as boolean,
  };

  public datePicker5 = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 3)),
    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 3)),
    currentDate: new Date() as Date,
    currentDate_input:
      "" /*this.datePipe.transform(new Date(), environment.dateFormat)*/,
    isActive: false as boolean,
  };

  public datePickerAddNote = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 3)),
    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 3)),
    currentDate: new Date() as Date,
    currentDate_input: this.datePipe.transform(
      new Date(),
      environment.dateFormat
    ),
    isActive: false as boolean,
  };

  public notes;

  public isUserLoaded = false;
  public isUnvaccinatedHorses: boolean;
  public unvaccinatedHorses: any[];

  public noteTypesList = [];

  public defaultNoteTypes = [
    NoteType.feed,
    NoteType.location,
    NoteType.training,
    NoteType.weight,
    NoteType.other,
  ];
  public noteTypes = [...this.defaultNoteTypes];
  public deactivateMultipleNotes = false;
  public hasSignNoteType = false;

  public vaccinationNumbers = ["primary", "secondary", "booster"];
  public routeTypes = [
    RouteTypes.intraVenous,
    RouteTypes.intraMuscular,
    RouteTypes.intraArticular,
    RouteTypes.oral,
    RouteTypes.other,
  ];

  public isImagesChanged = false;

  public treatmentsByDate = [] as any;
  public treatmentsByDateArchive = [] as any;

  public isRequestInProgress2 = false;
  public isRequestInProgress3 = false;
  public isRequestInProgress4 = false;
  public isRequestInProgress5 = false; /*todo*/
  public oneHorseId: any = false;
  public oneHorseName: any = false;
  public vaccinations: any[];

  public measuresSelectorModel: any;

  public drugs: any;

  public translation = {};

  public searchString: string;
  public sortObj = { field: "name", order: "asc" };
  public tabs = {
    isNormalTreatment: true as boolean,
    isQuickTreatment: false as boolean,
  };

  public userRoleId: number;

  public quick_treatment = environment.quick_treatment;
  public vaccinationCountries = [].concat(
    [environment.currentCountry],
    environment.vaccinationCountries
  );
  public currentCountry = environment.currentCountry;
  public isUSCountry = this.currentCountry.toLowerCase() === "us";
  public isAUSCountry = this.currentCountry.toLowerCase() === "aus";

  public horsesCondensedListView = false;

  public administers: Administer[] = [];
  public administer: Administer[] = [];

  constructor(
    private notificationsService: NotificationsService,
    public appMemory: AppMemoryService,
    public getService: GetService,
    public datePipe: DatePipe,
    public router: Router,
    public route: ActivatedRoute,
    public translateService: TranslateService,
    public billingService: BillingService,
    private http: HttpClient
  ) {
    this.isYardPage = this.route.params["value"]["yard_id"] ? true : false;
    this.yard_id = this.route.params["value"]["yard_id"] || null;

    if (this.currentCountry == "uk") {
      this.doUnvaccinateGetApi =
        this.route.params["value"]["en_region"] == "false" ? false : true;
    }

    this.appMemory.userSubject.subscribe((e) => {
      if (this.appMemory.user && e && !this.isUserLoaded) {
        this.route.queryParams.subscribe((params) => {
          this.searchString = params.search;
          this.getHorsesByUserRole();
        });

        this.isUserLoaded = true;

        if (this.searchString) {
          return;
        }

        // this.getHorsesByUserRole();
      }

      // this.getService.getFarms().then(
      //     res => {
      //         res.data.forEach(e => {
      //             e.text = e.name;
      //         });
      //         this.farms = res.data;
      //     },
      //     err => {
      //     }
      // );
    });

    this.getYard();
    this.getTranslation();
  }

  filterDrugs() {
    if (environment.filterRegionForDrugs) {
      this.drugs = this.appMemory.static.drugs.filter(
        (drug: any) => drug.region === this.newHorse.farm.region
      );
    }

    if (this.currentCountry == CurrentCountryTypes.US) {
      if (!this.drugs.includes(this.appMemory.static.drugs[0])) {
        this.drugs.unshift(this.appMemory.static.drugs[0]);
      }
    }
  }

  public calcQuantityMaxLength() {
    return 5;
  }

  ngOnInit(): void {
    this._searchStream.debounceTime(200).subscribe((res) => {
      if (res && res.length > 0) {
        this.getFarms(res);
      }
    });

    if (this.currentCountry == 'aus') {
      this.changeList();
    } else {
      !this.appMemory.horsesListViewType() ||
        this.appMemory.horsesListViewType() === "grid"
        ? this.changeGrid()
        : this.changeList();
    }


    this.appMemory.staticLoaded.subscribe((val) => {
      // tslint:disable-next-line:curly
      if (!val) return;

      this.noteTypesList = this.appMemory.static.notes || [];

      this.appMemory.userSubject.subscribe((e) => {
        if (this.appMemory.user && e && !this.isUserLoaded) {
          this.isUserLoaded = true;
          this.userRoleId = this.appMemory.user.roles[0].id;
        }
      });
    });
  }

  userCanAddHorseNote(horse) {
    return (
      horse.farm.region === usaRegionPK ||
      horse.farm.region === usaRegionPC ||
      this.appMemory.user.roles[0].id !== 3
    );
  }

  triggerClick() {
    $("#premium-link").trigger("click");
  }

  public selectedHorse = [];

  selectHorse(horse) {
    if (!horse.is_active) {
      return false;
    }
    horse.isSelected = !horse.isSelected;
    if (horse.isSelected) {
      this.selectedHorse.push(horse.id);
    } else {
      this.selectedHorse.splice(this.selectedHorse.indexOf(horse.id), 1);
    }

    if (this.currentCountry == CurrentCountryTypes.US) {
      this.selectedHorsesCanAddNote();
    }
  }

  selectAll() {
    this.selectedHorse = [];
    this.allSelected = !this.allSelected;
    this.horses.forEach((el) => {
      if (el.farm.region != this.UKRegions.Aintree && el.is_active) {
        if ((!el.isSelected || el.isSelected) && this.allSelected) {
          this.selectedHorse.push(el.id);
          el.isSelected = true;
        } else {
          el.isSelected = false;
        }
      }
    });

    if (this.currentCountry == CurrentCountryTypes.US) {
      this.selectedHorsesCanAddNote();
    }
  }

  selectedHorsesCanAddNote() {
    const [{ id: roleId = undefined } = {}] = this.appMemory.user.roles || [];

    if (roleId !== 3 && !this.selectedHorse.length) {
      this.deactivateMultipleNotes = false;
    }

    const regions = this.horses
      .filter((horse) => this.selectedHorse.includes(horse.id))
      .map((horse) => horse.farm.region);

    this.hasSignNoteType =
      (regions.includes(usaRegionPK) &&
        regions.every((region) => region === usaRegionPK)) ||
      (regions.includes(usaRegionPC) &&
        regions.every((region) => region === usaRegionPC));

    this.deactivateMultipleNotes =
      (roleId !== 3 &&
        regions.length &&
        ((regions.includes(usaRegionPK) &&
          !regions.every((region) => region === usaRegionPK)) ||
          (regions.includes(usaRegionPC) &&
            !regions.every((region) => region === usaRegionPC)))) ||
      (roleId === 3 && !this.hasSignNoteType);

    this.newNote = new Note(this.hasSignNoteType);

    this.setNoteTypes();
  }

  setNoteTypes() {
    this.noteTypes = (!this.hasSignNoteType && this.defaultNoteTypes) || [
      NoteType.sign,
    ];
  }

  getUnvaccinatedHorses(role: string) {
    if (environment.showModalUnvaccinated && this.doUnvaccinateGetApi) {
      this.getService.getUnvaccinatedHorses(role, this.yard_id).then(
        (res: any) => {
          if (res && res.length > 0) {
            this.unvaccinatedHorses = res;
            $("#unvaccinated-link").trigger("click");
          }
        },
        (err: any) => {
          console.log(err);
        }
      );
    }
  }

  getYard() {
    if (this.yard_id) {
      this.getService.getFarm(this.yard_id).then(
        (res) => {
          this.farm = res;
          this.updateFarm = Object.assign({}, this.farm);
          this.appMemory.countries.subscribe((countries) => {
            if (countries) {
              countries.forEach((e) => {
                e.text = e.name;
                if (this.farm && e.id === this.farm.country_id) {
                  this.selectedCountry = [e];
                }
              });

              this.countries = countries;
            }
          });

          this.appMemory.regions.subscribe((regions) => {
            if (regions) {
              regions.forEach((e) => {
                e.text = e.name;
                if (this.farm && e.id === this.farm.region) {
                  this.selectedRegion = [e];
                }
              });

              this.regions = regions;
            }
          });
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }

  objectToArray(obj: Object) {
    return Object.keys(obj).map((key) => obj[key]); // transorm Array-like Object to Array
  }

  searchDrugs(e) {
    this.drugs = [];
    this.drugs[0] = this.appMemory.static.drugs[0];
    if (this.appMemory.static.drugs) {
      this.appMemory.static.drugs.forEach((el, i) => {
        if (
          el.name.toLowerCase().indexOf(e.toLowerCase()) !== -1 &&
          el.name.toLowerCase().indexOf(this.drugs[0].name.toLowerCase()) === -1
        ) {
          this.drugs.push(el);
        }
      });
    }
  }

  getSelectedHorses() {
    const horses = [];
    if (this.horses && this.selectedHorse) {
      this.horses.map((value) => {
        if (this.selectedHorse.includes(value.id) && value.is_active) {
          horses.push(value);
        }
      });
    }
    return horses;
  }

  sortHorseBy(field) {
    this.sortObj.order =
      this.sortObj.field === field
        ? this.sortObj.order === "asc"
          ? "desc"
          : "asc"
        : "asc";
    this.sortObj.field = field;

    this.getHorsesByUserRole();
  }

  getHorsesByUserRole() {
    switch (this.appMemory.user.roles[0].id) {
      case 1:
        this.getHorses();
        if (!this.isUnvaccinatedHorses) {
          this.getUnvaccinatedHorses("/instructor");
          this.isUnvaccinatedHorses = true;
        }
        break;

      case 2:
        this.getInstructorHorses();
        if (!this.isUnvaccinatedHorses) {
          this.getUnvaccinatedHorses("/assistant");
          this.isUnvaccinatedHorses = true;
        }
        break;

      case 3:
        this.getVetHorses();
        if (!this.isUnvaccinatedHorses) {
          this.getUnvaccinatedHorses("/vet");
          this.isUnvaccinatedHorses = true;
        }
        break;
    }
  }

  getHorses() {
    this.isRequestInProgress = true;

    this.getService
      .getHorses(true, this.searchString, this.yard_id, this.sortObj)
      .then(
        (res: any) => {
          this.horses = res.data;

          if (res.next_page_url) {
            this.pagination.nextPage =
              res.next_page_url +
              "&treatment=true" +
              (this.searchString ? "&q=" + this.searchString : "") +
              (this.yard_id ? "&farm_id=" + this.yard_id : "") +
              (this.sortObj.field
                ? "&order[field]=" + this.sortObj.field
                : "") +
              (this.sortObj.order ? "&order[order]=" + this.sortObj.order : "");
          } else {
            this.pagination.nextPage = res.next_page_url;
          }

          this.isRequestInProgress = false;
        },
        (err: any) => {
          this.isRequestInProgress = false;
        }
      );
  }

  getInstructorHorses() {
    this.isRequestInProgress = true;

    this.getService
      .getInstructorHorses(true, this.searchString, this.yard_id, this.sortObj)
      .then(
        (res: any) => {
          this.horses = res.data;

          if (res.next_page_url) {
            this.pagination.nextPage =
              res.next_page_url +
              "&treatment=true" +
              (this.searchString ? "&q=" + this.searchString : "") +
              (this.yard_id ? "&farm_id=" + this.yard_id : "") +
              (this.sortObj.field
                ? "&order[field]=" + this.sortObj.field
                : "") +
              (this.sortObj.order ? "&order[order]=" + this.sortObj.order : "");
          } else {
            this.pagination.nextPage = res.next_page_url;
          }

          this.isRequestInProgress = false;
        },
        (err: any) => {
          this.isRequestInProgress = false;
        }
      );
  }

  getVetHorses() {
    this.isRequestInProgress = true;

    this.getService
      .getVetHorses(true, this.searchString, this.yard_id, this.sortObj)
      .then(
        (res: any) => {
          this.horses = res.data;

          if (res.next_page_url) {
            this.pagination.nextPage =
              res.next_page_url +
              "&treatment=true" +
              (this.searchString ? "&q=" + this.searchString : "") +
              (this.yard_id ? "&farm_id=" + this.yard_id : "") +
              (this.sortObj.field
                ? "&order[field]=" + this.sortObj.field
                : "") +
              (this.sortObj.order ? "&order[order]=" + this.sortObj.order : "");
          } else {
            this.pagination.nextPage = res.next_page_url;
          }

          this.isRequestInProgress = false;
        },
        (err: any) => {
          this.isRequestInProgress = false;
        }
      );
  }

  cardRequired(res: any) {
    if (typeof res.card_required !== "undefined") {
      if (res.card_required && res.out_of_range) {
        $("body").addClass("modal-open");
        this.billingService.setShow(true);
      }
    }
  }

  uploadFileToS3(presigned_urls: PresignedResponse[]) {
    this.http.put(presigned_urls[0].url, this.newHorse.microchip).subscribe(
      (response) => {
        console.log("response from the s3", response);
      },
      (error) => {
        console.error("Error uploading file in create horse", error);
      }
    );
  }

  uploadBulkFilesToS3(presigned_urls: PresignedResponse[], files: any[]) {
    var horses = Array.from(new Set(presigned_urls.map((item) => item.horse)));
    for (const horse of horses) {
      presigned_urls.forEach((response, index) => {
        var src = files.find((src) => src.file.name == response.filename && response.horse == horse);
        if (src) {
          this.http.put(response.url, src.file).subscribe(
            (response) => {
              console.log("response from the s3", response);
            },
            (error) => {
              console.error("Error uploading file", error);
            }
          );

          src = "";
        }
      });
    }
  }

  createHorse(form: any) {
    if (form.form.invalid || !this.newHorse.gender_id) {
      return;
    }

    const ass =
      this.appMemory.user &&
      this.appMemory.user.roles &&
      this.appMemory.user.roles.length > 0 &&
      this.appMemory.user.roles[0].id === 2;
    const formData: FormData = new FormData();

    formData.append("gender_id", this.newHorse.gender_id.toString());
    formData.append("name", this.newHorse.name);
    formData.append("birth", this.newHorse.birth);

    formData.append("hisa_id", this.newHorse.hisa_id);

    if (this.newHorse.description) {
      formData.append("description", this.newHorse.description);
    }
    formData.append("farm_id", this.newHorse.farm_id.toString());
    if (this.showInTheFoodChainToggle) {
      formData.append(
        "is_in_food_chain",
        this.newHorse.is_in_food_chain ? 1 : 0
      );
    }
    formData.append("in_training", this.newHorse.in_training ? 1 : 0);
    formData.append(
      "microchip_number",
      this.newHorse.microchip_number.toString()
    );

    if (this.newHorse.microchip) {
      if (this.appMemory.static.appStorageType == AppStorageType.fileSystem) {
        formData.append(
          "microchip",
          this.newHorse.microchip,
          this.newHorse.microchip.name
        );
      } else {
        formData.append(
          "presigned_urls",
          JSON.stringify([{ filename: this.newHorse.microchip.name, update_image: true }])
        );
      }
    }
    this.isRequestInProgress = true;

    this.getService.createHorse(formData, ass).then(
      (res: any) => {
        if (
          this.newHorse.microchip &&
          res.presigned_urls &&
          res.presigned_urls.length > 0
        ) {
          this.uploadFileToS3(res.presigned_urls);
        }
        this.cardRequired(res);

        this.isRequestInProgress = false;

        this.clearUserInput(this.createHorseForm);
        this.hideModal();
        this.getHorsesByUserRole();
        this.notificationsService.success(
          `${this.translation["addHorse"]}`,
          `${this.translation["horse"]} ${this.translation["addedSuccess"]}`
        );
        if (res.out_of_range) {
          this.isTrial = res.is_trial;
          $("#premium-link").trigger("click");
        }
      },
      (err: any) => {
        this.isRequestInProgress = false;
        this.notificationsService.error(
          `${this.translation["addHorse"]}`,
          `${this.translation["errorOccurred"]}`
        );
        this.serverError =
          err._body && JSON.parse(err._body)
            ? this.objectToArray(JSON.parse(err._body))
            : `${this.translation["errorOccurred"]}`;
      }
    );
  }

  createTreatment(role: string, form: any) {
    if (
      form.form.invalid ||
      !this.newTreatment.drug ||
      !this.newTreatment.route ||
      !this.newTreatment.withdrawal ||
      !this.newTreatment.start_date ||
      !this.newTreatment.quantity_measure
    ) {
      return;
    }

    this.isRequestInProgress4 = true;

    const formData: FormData = new FormData();

    if (this.oneHorseId === false) {
      this.selectedHorse.map((value, key) => {
        formData.append("horse_id[" + key + "]", value);
      });
    } else {
      formData.append("horse_id[0]", this.oneHorseId);
    }

    formData.append("type", "other");

    if (this.newTreatment.drug && this.newTreatment.drug.id) {
      formData.append("drug_id", this.newTreatment.drug.id);
    }

    if (!this.newTreatment.drug || !this.newTreatment.drug.id) {
      formData.append("drug_name", this.newTreatment.drug_name);
    }

    formData.append("route", this.newTreatment.route);

    if (
      this.newTreatment.route &&
      this.newTreatment.route.toLowerCase() === "other"
    ) {
      formData.append("other_route", this.newTreatment.other_route);
    }

    if (this.currentCountry == "uk") {
      formData.append("frequency", this.newTreatment.frequency);
    }

    formData.append("reason", this.newTreatment.reason);
    formData.append("start_date", this.newTreatment.start_date);
    formData.append("withdrawal", this.newTreatment.withdrawal);
    formData.append("quantity", this.newTreatment.quantity.toString());
    formData.append("other_quantity", this.newTreatment.other_quantity || "");
    formData.append("quantity_measure", this.newTreatment.quantity_measure);
    /*formData.append("detection_time", this.newTreatment.detection_time);*/
    formData.append("duration", this.newTreatment.duration.toString());

    if (!!this.newTreatment.administer) {
      if (this.newTreatment.administer.user_id <= 0) {
        this.newTreatment.administer.user_id = null;
      }
      Object.keys(this.newTreatment.administer).forEach((key) => {
        formData.append(
          `administer[${key}]`,
          this.newTreatment.administer[key]
        );
      });
    }

    var update_image = false;
    if (this.newTreatment.src && this.isImagesChanged) {
      update_image = true;
      const imgs = $(".with_description .image-container .image");
      if (this.appMemory.static.appStorageType == AppStorageType.fileSystem) {
        this.newTreatment.src.forEach((e, i) => {
          formData.append("images[" + i + "][content]", e.file, e.file.name);
          formData.append(
            "images[" + i + "][description]",
            $(imgs[i]).find("input").val()
          );
        });
      } else {
        var selectedHorses = this.oneHorseId === false ? this.selectedHorse : [this.oneHorseId];
        var presignedUrls = [];

        for (const horse of selectedHorses) {
          presignedUrls = presignedUrls.concat(this.newTreatment.src.map((e, i) => ({
            horse: horse,
            filename: e.file.name,
            description: $(imgs[i]).find("input").val(),
            update_image: update_image
          })));
        }

        formData.append("presigned_urls", JSON.stringify(presignedUrls));
      }
    }

    switch (this.appMemory.user.roles[0].id) {
      case 1:
        this.getService.createTreatment(role, formData).then(
          (res: any) => {
            if (
              this.newTreatment.src &&
              res.presigned_urls &&
              res.presigned_urls.length > 0
            ) {
              this.uploadBulkFilesToS3(res.presigned_urls, this.newTreatment.src);
              update_image = false;
            }
            this.clearUserInput(this.createTreatmentForm);
            this.hideModal();
            this.treatmentsByDate = [];
            this.treatmentsByDateArchive = [];
            this.isRequestInProgress4 = false;
            // this.getHorse('/treatments');
            this.notificationsService.success(
              `${this.translation["addTreat"]}`,
              `${this.translation["treatment"]} ${this.translation["addedSuccess"]}`
            );
          },
          (err: any) => {
            console.log("ERR", err);
            this.isRequestInProgress4 = false;
            this.notificationsService.error(
              `${this.translation["addTreat"]}`,
              `${this.translation["errorOccurred"]}`
            );
            this.serverError = this.objectToArray(JSON.parse(err._body));
          }
        );
        break;

      case 2:
        this.getService.createTreatmentMA(role, formData).then(
          (res: any) => {
            if (
              this.newTreatment.src &&
              res.presigned_urls &&
              res.presigned_urls.length > 0
            ) {
              this.uploadBulkFilesToS3(res.presigned_urls, this.newTreatment.src);
              update_image = false;
            }
            this.clearUserInput(this.createTreatmentForm);
            this.hideModal();
            this.treatmentsByDate = [];
            this.treatmentsByDateArchive = [];
            this.isRequestInProgress4 = false;
            // this.getHorse('/treatments');
            this.notificationsService.success(
              `${this.translation["addTreat"]}`,
              `${this.translation["treatment"]} ${this.translation["addedSuccess"]}`
            );
          },
          (err: any) => {
            this.isRequestInProgress4 = false;
            this.notificationsService.error(
              `${this.translation["addTreat"]}`,
              `${this.translation["errorOccurred"]}`
            );
            this.serverError = this.objectToArray(JSON.parse(err._body));
          }
        );
        break;

      case 3:
        this.getService.createTreatmentMV(role, formData).then(
          (res: any) => {
            if (
              this.newTreatment.src &&
              res.presigned_urls &&
              res.presigned_urls.length > 0
            ) {
              this.uploadBulkFilesToS3(res.presigned_urls, this.newTreatment.src);
              update_image = false;
            }
            this.clearUserInput(this.createTreatmentForm);
            this.hideModal();
            this.treatmentsByDate = [];
            this.treatmentsByDateArchive = [];
            this.isRequestInProgress4 = false;
            // this.getHorse('/treatments');
            this.notificationsService.success(
              `${this.translation["addTreat"]}`,
              `${this.translation["treatment"]} ${this.translation["addedSuccess"]}`
            );
          },
          (err: any) => {
            console.log("ERR", err);
            this.isRequestInProgress4 = false;
            this.notificationsService.error(
              `${this.translation["addTreat"]}`,
              `${this.translation["errorOccurred"]}`
            );
            this.serverError = this.objectToArray(JSON.parse(err._body));
          }
        );
        break;
    }
  }

  clearSelectedHorses() {
    if (this.oneHorseId === true) {
      for (const horse of this.horses) {
        if (this.selectedHorse.includes(horse.id)) {
          horse.isSelected = false;
        }
      }
    }
    this.selectedHorse = [];
  }

  createQuickTreatment(role: string, form: any) {
    if (!this.newTreatment.src || !this.newTreatment.src.length) {
      return;
    }
    this.isRequestInProgress4 = true;

    const formData: FormData = new FormData();

    this.selectedHorse.map((value, key) => {
      formData.append("horses_id[" + key + "]", value);
    });

    if (this.newTreatment.src && this.isImagesChanged) {
      const imgs = $(".with_description .image-container .image");
      this.newTreatment.src.forEach((e, i) => {
        formData.append("images[" + i + "][content]", e.file, e.file.name);
        formData.append(
          "images[" + i + "][description]",
          $(imgs[i]).find("input").val()
        );
      });
    }

    this.getService.createQuickTreatment(role, formData).then(
      (res: any) => {
        this.clearUserInput(this.createTreatmentForm);
        this.hideModal();
        this.treatmentsByDate = [];
        this.treatmentsByDateArchive = [];
        this.isRequestInProgress4 = false;
        this.newTreatment.src = "";
        this.getHorsesByUserRole();
        this.notificationsService.success(
          `${this.translation["addTreat"]}`,
          `${this.translation["treatment"]} ${this.translation["addedSuccess"]}`
        );
      },
      (err: any) => {
        this.isRequestInProgress4 = false;
        this.notificationsService.error(
          `${this.translation["addTreat"]}`,
          `${this.translation["errorOccurred"]}`
        );
        this.serverError = this.objectToArray(JSON.parse(err._body));
      }
    );
  }

  createVaccination(form: any) {
    if (
      form.form.invalid ||
      !this.newVaccination.date ||
      (!this.newVaccination.other && !this.newVaccination.number) ||
      (this.newVaccination.other &&
        ((this.newVaccination.other && !this.newVaccination.immunization) ||
          !this.newVaccination.name))
    ) {
      this.invalidVaccinationForm = true;
      return;
    }

    if (this.currentCountry != CurrentCountryTypes.US) {
      this.newVaccination.vaccination_countries = [
        ...this.vaccinationCountries,
      ].filter((country) => country !== this.currentCountry);
    }

    this.isRequestInProgress = true;
    let data;
    if (this.oneHorseId === false) {
      data = { ...this.newVaccination, horse_id: this.selectedHorse };
    } else {
      data = { ...this.newVaccination, horse_id: [this.oneHorseId] };
    }
    this.getService.addVaccinationBulk(data).then(
      (res: any) => {
        $("#assistant-invite-email-box").removeClass("input--filled");
        this.clearUserInput(form);
        this.hideModal();
        this.vaccinations = [];
        // this.getHorseByUserRole();
        this.isRequestInProgress = false;
        this.notificationsService.success(
          `${this.translation["addVacs"]}`,
          `${this.translation["vacc"]} ${this.translation["addedSuccess"]}`
        );
      },
      (err: any) => {
        // console.log('ERR', err);
        this.isRequestInProgress = false;

        if (err.status === 422) {
          let text = "";
          if (JSON.parse(err._body).error.length) {
            JSON.parse(err._body).error.map((value) => {
              text += value.error + "  \n";
            });
          }
          this.notificationsService.error(
            `${this.translation["addVacs"]}`,
            text ? text : `${this.translation["errorOccurred"]}`
          );

          return;
        }

        this.notificationsService.error(
          `${this.translation["addVacs"]}`,
          `${this.translation["errorOccurred"]}`
        );
      }
    );
  }

  addNodeSetDefaultDate() {
    this.datePickerAddNote.currentDate_input = this.datePipe.transform(
      new Date(),
      environment.dateFormat
    );
  }

  prepareHorseNote(horse: Horse) {
    this.oneHorseId = horse.id;
    this.oneHorseName = horse.name;
    this.hasSignNoteType =
      horse.farm.region === usaRegionPK || horse.farm.region === usaRegionPC;
    this.setNoteTypes();
  }

  createNote(role: string, form: any) {
    if (
      form.form.invalid ||
      (this.newNote.type === "weight" && !this.newNote.weight)
    ) {
      return;
    }

    const formData: FormData = new FormData();

    Object.keys(this.newNote)
      .filter((key) => !["src"].includes(key))
      .forEach((key) => {
        formData.append(key, this.newNote[key]);
      });

    this.isRequestInProgress = true;
    if (this.oneHorseId === false) {
      this.selectedHorse.map((value, key) => {
        formData.append("horse_id[" + key + "]", value);
      });
    } else {
      formData.append("horse_id[0]", this.oneHorseId);
    }
    if (this.newNote.type !== "weight") {
      this.newNote.weight = undefined;
    } else {
      formData.append("weight", this.newNote.weight);
    }

    if (this.newNote.date === undefined) {
      this.setNoteDate(new Date());
    }

    formData.append("title", this.newNote.title);
    formData.append("description", this.newNote.description);
    //formData.append("type", this.newNote.type);

    formData.append(
      "type",
      this.hasSignNoteType ? NoteType.sign : this.newNote.type
    );
    formData.append("date", this.newNote.date);

    var update_image = false;
    if (this.newNote.src && this.isImagesChanged) {
      update_image = true;
      const imgs = $(".with_description .image-container .image");
      if (this.appMemory.static.appStorageType == AppStorageType.fileSystem) {
        this.newNote.src.forEach((e, i) => {
          formData.append("images[" + i + "][content]", e.file, e.file.name);
          formData.append(
            "images[" + i + "][description]",
            $(imgs[i]).find("input").val()
          );
        });
      } else {
        var selectedHorses = this.oneHorseId === false ? this.selectedHorse : [this.oneHorseId];
        var presignedUrls = [];

        for (const horse of selectedHorses) {
          presignedUrls = presignedUrls.concat(this.newNote.src.map((e, i) => ({
            horse: horse,
            filename: e.file.name,
            description: $(imgs[i]).find("input").val(),
            update_image: update_image
          })));
        }

        formData.append("presigned_urls", JSON.stringify(presignedUrls));
      }
    }

    this.getService.addNoteBulk(formData).then(
      (res: any) => {
        if (
          this.newNote.src &&
          res.presigned_urls &&
          res.presigned_urls.length > 0
        ) {
          this.uploadBulkFilesToS3(res.presigned_urls, this.newNote.src);
          update_image = false;
        }
        $("#assistant-invite-email-box").removeClass("input--filled");
        this.clearUserInput(form);
        this.hideModal();
        this.notes = [];
        // this.getHorseByUserRole();
        this.isRequestInProgress = false;
        this.notificationsService.success(
          `${this.translation["addNote"]}`,
          `${this.translation["note"]} ${this.translation["addedSuccess"]}`
        );
      },
      (err: any) => {
        console.log("ERR", err);
        this.isRequestInProgress = false;
        this.notificationsService.error(
          `${this.translation["addNote"]}`,
          `${this.translation["errorOccurred"]}`
        );
      }
    );
  }

  submitUpdateFarm(form: any) {
    if (form.form.invalid || !this.updateFarm.country_id) {
      return;
    }

    const formData = {
      name: this.updateFarm.name,
      address_first: this.updateFarm.address_first,
      address_second: this.updateFarm.address_second,
      city: this.updateFarm.city,
      region: this.updateFarm.region,
      post_code: this.updateFarm.post_code,
      country_id: this.updateFarm.country_id,
    };

    this.isRequestInProgress = true;

    this.getService.updateFarm(this.yard_id, formData).then(
      (res: any) => {
        this.isRequestInProgress = false;

        this.clearUserInput(this.updateFarmForm);
        this.hideModal();
        this.getFarms();
        this.notificationsService.success(
          `${this.translation["addYard"]}`,
          `${this.translation["yard"]} ${this.translation["addedSuccess"]}`
        );
      },
      (err: any) => {
        this.isRequestInProgress = false;
        this.notificationsService.error(
          `${this.translation["addYard"]}`,
          `${this.translation["errorOccurred"]}`
        );
        this.serverError = this.objectToArray(JSON.parse(err._body));
      }
    );
  }

  clearFarmInput(form: any) {
    this.serverError = null;
    form.resetForm();
    this.updateFarm = new Farm();
    $("#farm-name-box").removeClass("input--filled");
    $("#farm-descr-box").removeClass("input--filled");
    $("#microchip-number-box").removeClass("input--filled");
  }

  clearImages() {
    if (this.imageLoader) {
      this.imageLoader.deleteAll();
    }
    if (this.imageLoader22) {
      this.imageLoader22.deleteAll();
    }
    if (this.imageLoader23) {
      this.imageLoader23.deleteAll();
    }
  }

  clearUserInput(form?: any) {
    this.clearImages();
    this.serverError = null;
    if (form) {
      form.resetForm();
      if (this.currentCountry == CurrentCountryTypes.US) {
        this.selectedHorsesCanAddNote();
      }
    }
    this.oneHorseId = false;
    // this.newNote = new Note();
    if (this.currentCountry == CurrentCountryTypes.US) {
      this.newNote = new Note(this.hasSignNoteType);
    }
    this.newTreatment = new Treatment();
    this.newVaccination = new Vaccination();
    // this.measuresSelectorModel = [];
    // this.weightsSelectorModel = [];
    $("#note-title-box").removeClass("input--filled");
    $("#note-descr-box").removeClass("input--filled");
    $("#comment-box").removeClass("input--filled");
    $("#quantity-box").removeClass("input--filled");
    $("#reason-box").removeClass("input--filled");
    /*$('#detection_time-box').removeClass('input--filled');*/
    $("#duration-box").removeClass("input--filled");
    $("#microchip-number-box").removeClass("input--filled");
    this.datePicker.isActive = false;
    this.datePicker2.isActive = false;
    this.datePicker3.isActive = false;
    this.datePicker4.isActive = false;
    this.datePicker5.isActive = false;
    this.datePickerAddNote.isActive = false;
    this.dateRangeErrorMessage = {} as {
      from?: string;
      due?: string;
      date?: string;
    };
    this.dateRangeTreatmentErrorMessage = {} as {
      from?: string;
      due?: string;
      date?: string;
    };
    this.newHorse = new Horse();
    this.imageLoader.deleteAll();
    this.imageLoader22.deleteAll();
    this.imageLoader23.deleteAll();
    this.farmsSelector.active = [];
    if (this.appMemory.user.farm) {
      this.farmsSelector.active.push({
        id: this.appMemory.user.farm.id,
        text: this.appMemory.user.farm.name,
      });
    }
    // this.selectedHorse = [];
    this.farmsSelector.items = [];
    this.datePicker.currentDate = new Date() as Date;
    this.datePicker.currentDate_input = this.datePipe.transform(
      new Date(),
      environment.dateFormat
    );
    this.datePicker.isActive = false;
    this.serverErrorValidate = null;

    $("#horse-name-box").removeClass("input--filled");
    $("#horse-descr-box").removeClass("input--filled");
    $("#microchip-number-box").removeClass("input--filled");
  }

  getAge(dateString) {
    const today = new Date();
    const birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  debug(e) {
    console.log(e);
  }

  hideModal() {
    $(".modal.open").removeClass("open");
    $("body").removeClass("modal-open");
  }

  addNewData(items: any) {
    if (
      this.pagination.nextPage === null ||
      this.pagination.inProgress ||
      this.pagination.nextPage === ""
    ) {
      return;
    }

    this.pagination.inProgress = true;
    this.getService.rawRequest(this.pagination.nextPage, this.yard_id).then(
      (res: any) => {
        res.data.forEach((item: any) => {
          items.push(item);
        });

        if (res.next_page_url) {
          this.pagination.nextPage =
            res.next_page_url +
            "&treatment=true" +
            (this.searchString ? "&q=" + this.searchString : "") +
            (this.yard_id ? "&farm_id=" + this.yard_id : "") +
            (this.sortObj.field ? "&order[field]=" + this.sortObj.field : "") +
            (this.sortObj.order ? "&order[order]=" + this.sortObj.order : "");
        } else {
          this.pagination.nextPage = res.next_page_url;
        }

        this.pagination.inProgress = false;
      },
      (err: any) => {
        this.pagination.inProgress = false;
      }
    );
  }

  getFarms(name?: string) {
    this.farmsSelector.items = [];
    this.loadSuggestion = true;
    if (name) {
      return (this.farms = this.farms.filter((farm) =>
        new RegExp(".*" + name + ".*").test(farm.name)
      ));
    }
    return this.getService.getAllFarms().then(
      (res) => {
        res.forEach((e) => {
          e.text = e.name;
        });
        this.farms = res;
        if (this.farms.length === 1) {
          this.setFarmId(this.farms[0]);
        }
        this.loadSuggestion = false;

        setTimeout(() => {
          // this.farmsSelector.open();
        }, 100);
      },
      (err) => {
        this.loadSuggestion = false;
      }
    );
  }

  changeList() {
    document.getElementById("list").style.display = "block";
    document.getElementById("listView").style.color = "#c09241";
    if (!this.isAUSCountry) {
      document.getElementById("grid").style.display = "none";
      document.getElementById("gridView").style.color = "#9b9b9b";
      document.getElementById("condensedView").style.color = "#9b9b9b";
    }

    this.appMemory.horsesListViewType("list");
    this.horsesCondensedListView = false;
  }

  changeCondensedView() {
    document.getElementById("list").style.display = "block";
    document.getElementById("grid").style.display = "none";
    document.getElementById("gridView").style.color = "#9b9b9b";
    document.getElementById("listView").style.color = "#9b9b9b";
    document.getElementById("condensedView").style.color = "#c09241";

    this.appMemory.horsesListViewType("condensedView");
    this.horsesCondensedListView = true;
  }

  changeGrid() {
    document.getElementById("list").style.display = "none";
    if (this.currentCountry != 'uk') {
      document.getElementById("grid").style.display = "block";
      document.getElementById("gridView").style.color = "#c09241";
      document.getElementById("condensedView").style.color = "#9b9b9b";
    }
    document.getElementById("listView").style.color = "#9b9b9b";

    this.appMemory.horsesListViewType("grid");
    this.horsesCondensedListView = false;
  }

  setFarmId(e) {
    this.newHorse.farm_id = e.id;

    const selectedFarm: Farm = this.farms.find((item: Farm) => item.id == e.id);

    if (selectedFarm && selectedFarm.region != usaRegionBC2023) {
      this.newHorse.hisa_id = "";
    }
  }

  setMeasure(e) {
    this.newTreatment.quantity_measure = e.id;
  }

  setWithdrawal(date) {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.withdrawal = null;
    }
    this.newTreatment.withdrawal = this.datePipe
      .transform(date, "yyyy-MM-dd")
      .replace(/\s/g, "T");
    this.datePicker2.currentDate = date;
    this.datePicker4.maxDate = date;
    this.datePicker2.currentDate_input = this.datePipe.transform(
      date,
      environment.dateFormat
    );
  }

  setWithdrawalInput() {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.withdrawal = null;
    }
    // (new Date(this.formatDate(this.datePicker2.currentDate_input))).getTime() > this.datePicker2.maxDate.getTime() ||
    // (new Date(this.formatDate(this.datePicker2.currentDate_input))).getTime() < this.datePicker2.minDate.getTime() ||
    if (
      new Date(
        this.formatDate(this.datePicker2.currentDate_input)
      ).toDateString() === "Invalid Date"
    ) {
      if (this.serverErrorValidate) {
        this.serverErrorValidate.withdrawal = "CORE.invalidDate";
      } else {
        this.serverErrorValidate = { withdrawal: "CORE.invalidDate" };
      }
      return;
    }
    this.datePicker2.currentDate = new Date(
      this.formatDate(this.datePicker2.currentDate_input)
    );
    this.newTreatment.withdrawal = this.datePipe.transform(
      this.formatDate(this.datePicker2.currentDate_input),
      "yyyy-MM-dd"
    );
    this.datePicker2.isActive = false;
  }

  setStartDate(date) {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.start_date = null;
    }
    this.newTreatment.start_date = this.datePipe
      .transform(date, "yyyy-MM-dd")
      .replace(/\s/g, "T");
    this.datePicker4.currentDate = date;
    this.datePicker2.minDate = date;
    this.datePicker4.currentDate_input = this.datePipe.transform(
      date,
      environment.dateFormat
    );
  }

  setStartDateInput() {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.start_date = null;
    }
    // (new Date(this.formatDate(this.datePicker4.currentDate_input))).getTime() > this.datePicker4.maxDate.getTime() ||
    // (new Date(this.formatDate(this.datePicker4.currentDate_input))).getTime() < this.datePicker4.minDate.getTime() ||
    if (
      new Date(
        this.formatDate(this.datePicker4.currentDate_input)
      ).toDateString() === "Invalid Date"
    ) {
      if (this.serverErrorValidate) {
        this.serverErrorValidate.start_date = "CORE.invalidDate";
      } else {
        this.serverErrorValidate = { start_date: "CORE.invalidDate" };
      }
      return;
    }
    this.datePicker4.currentDate = new Date(
      this.formatDate(this.datePicker4.currentDate_input)
    );
    this.newTreatment.start_date = this.datePipe.transform(
      this.formatDate(this.datePicker4.currentDate_input),
      "yyyy-MM-dd"
    );
    this.datePicker4.isActive = false;
  }

  /**
   * Check validity of period and disabled "Pick date" button
   * @returns {void}
   */
  checknewTreatmentValidity(): void {
    const options = { year: "numeric", month: "numeric", day: "numeric" };
    if (
      this.newTreatment.start_date &&
      this.newTreatment.withdrawal &&
      this.newTreatment.start_date > this.newTreatment.withdrawal
    ) {
      this.dateRangeTreatmentErrorMessage = {
        from: "OTHER.startDateGraterEndDate",
        due: "OTHER.startDateGraterEndDate",
      };
      this.invalidTreatmentForm = true;
    }
    // else if (new Date(this.newTreatment.start_date).getTime() < new Date(this.appMemory.user.created_at).getTime()) {
    //     this.dateRangeTreatmentErrorMessage = {
    //         from: `OTHER.dateExceededReg`,
    //         date: new Date(this.appMemory.user.created_at).toLocaleString('en-GB', options)
    //     };
    //     this.invalidTreatmentForm = true;
    // } else if (new Date(this.newTreatment.withdrawal).getTime() < new Date(this.appMemory.user.created_at).getTime()) {
    //     this.dateRangeTreatmentErrorMessage = {
    //         due: `OTHER.dateExceededReg`,
    //         date: new Date(this.appMemory.user.created_at).toLocaleString('en-GB', options)
    //     };
    //     this.invalidTreatmentForm = true;
    // }
    else {
      this.dateRangeTreatmentErrorMessage = {};
      this.invalidTreatmentForm = false;
    }
  }

  setVaccinationDate(date) {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.vaccination_date = null;
    }
    this.newVaccination.date = this.datePipe
      .transform(date, "yyyy-MM-dd")
      .replace(/\s/g, "T");
    this.datePicker3.currentDate = date;
    this.datePicker3.currentDate_input = this.datePipe.transform(
      date,
      environment.dateFormat
    );
    this.datePicker5.minDate = date;
  }

  setVaccinationDateInput() {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.vaccination_date = null;
    }
    // (new Date(this.formatDate(this.datePicker3.currentDate_input))).getTime() > this.datePicker3.maxDate.getTime() ||
    // (new Date(this.formatDate(this.datePicker3.currentDate_input))).getTime() < this.datePicker3.minDate.getTime() ||
    if (
      new Date(
        this.formatDate(this.datePicker3.currentDate_input)
      ).toDateString() === "Invalid Date"
    ) {
      if (this.serverErrorValidate) {
        this.serverErrorValidate.vaccination_date = "CORE.invalidDate";
      } else {
        this.serverErrorValidate = { vaccination_date: "CORE.invalidDate" };
      }
      return;
    }
    this.newVaccination.date = this.datePipe.transform(
      this.formatDate(this.datePicker3.currentDate_input),
      "yyyy-MM-dd"
    );
    this.datePicker3.currentDate = new Date(
      this.formatDate(this.datePicker3.currentDate_input)
    );
    this.datePicker3.isActive = false;
  }

  removeVaccinationDate() {
    this.newVaccination.date = undefined;
    this.datePicker.currentDate = new Date(
      new Date().setFullYear(new Date().getFullYear() - 3)
    );
  }

  setNextVaccinationDate(date) {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.immunization = null;
    }
    this.newVaccination.immunization = this.datePipe
      .transform(date, "yyyy-MM-dd")
      .replace(/\s/g, "T");
    this.datePicker5.currentDate = date;
    this.datePicker5.currentDate_input = this.datePipe.transform(
      date,
      environment.dateFormat
    );
    this.datePicker3.maxDate = date;
  }

  setNextVaccinationDateInput() {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.immunization = null;
    }
    // (new Date(this.formatDate(this.datePicker5.currentDate_input))).getTime() > this.datePicker5.maxDate.getTime() ||
    // (new Date(this.formatDate(this.datePicker5.currentDate_input))).getTime() < this.datePicker5.minDate.getTime() ||
    if (
      new Date(
        this.formatDate(this.datePicker5.currentDate_input)
      ).toDateString() === "Invalid Date"
    ) {
      if (this.serverErrorValidate) {
        this.serverErrorValidate.immunization = "CORE.invalidDate";
      } else {
        this.serverErrorValidate = { immunization: "CORE.invalidDate" };
      }
      return;
    }
    this.newVaccination.immunization = this.datePipe.transform(
      this.formatDate(this.datePicker5.currentDate_input),
      "yyyy-MM-dd"
    );
    this.datePicker5.currentDate = new Date(
      this.formatDate(this.datePicker5.currentDate_input)
    );
    this.datePicker5.isActive = false;
  }

  /**
   * Check validity of period and disabled "Pick date" button
   * @returns {void}
   */
  checknewVaccinationValidity(): void {
    const options = { year: "numeric", month: "numeric", day: "numeric" };
    if (
      this.newVaccination.date &&
      this.newVaccination.immunization &&
      this.newVaccination.date > this.newVaccination.immunization
    ) {
      this.dateRangeErrorMessage = {
        from: "OTHER.adminGreaterNextAdmin",
        due: "OTHER.adminGreaterNextAdmin",
      };
      this.invalidVaccinationForm = true;
    }
    // else if (new Date(this.newVaccination.date).getTime() < new Date(this.appMemory.user.created_at).getTime()) {
    //     this.dateRangeErrorMessage = {
    //         from: `OTHER.dateExceededReg`,
    //         date: new Date(this.appMemory.user.created_at).toLocaleString('en-GB', options)
    //     };
    //     this.invalidVaccinationForm = true;
    // } else if (new Date(this.newVaccination.immunization).getTime() < new Date(this.appMemory.user.created_at).getTime()) {
    //     this.dateRangeErrorMessage = {
    //         due: `OTHER.dateExceededReg`,
    //         date: new Date(this.appMemory.user.created_at).toLocaleString('en-GB', options)
    //     };
    //     this.invalidVaccinationForm = true;
    // }
    else {
      this.dateRangeErrorMessage = {};
      this.invalidVaccinationForm = false;
    }
  }

  setWeight(e) {
    this.newNote.weight = e.text;
  }

  resetDates() {
    this.removeVaccinationDate();
    this.removeNextVaccinationDate();
  }

  removeNextVaccinationDate() {
    this.newVaccination.immunization = undefined;
    this.datePicker.currentDate = new Date(
      new Date().setFullYear(new Date().getFullYear() + 3)
    );
  }

  setImages(file: File[]) {
    const that = this;

    this.newTreatment.src = file;
    this.isImagesChanged = true;

    setTimeout(() => {
      for (let i = 0; i < file.length; i++) {
        if (!(<any>file[i]).compressed) {
          new ImageCompressor((<any>file[i]).file, {
            maxWidth: 1000,
            maxHeight: 668,
            success(result) {
              (<any>file[i]).file = result;
              (<any>file[i]).compressed = true;
            },
            error(e) {
              console.log(e.message);
              this.notificationsService.error(
                `${this.translation["uploadImage"]}`,
                `${this.translation["errorOccurred"]}`
              );
            },
          });
        }
      }

      const imgs = $(".with_description .image-container .image");
      imgs.addClass("image-block");

      imgs.each((i) => {
        if ($(imgs[i]).find(".remove_on_remove_img").length === 0) {
          const a = `<div class="box-control remove_on_remove_img">
              <input type="text"
                     class="form-control input__field"
                     name="image_description_${i}"
                     autocomplete="off">
              <label class="input__label">
                <span>${this.translation["uploadImage"]}</span>
              </label>
            </div>`;
          $(a).appendTo(imgs[i]);
        }
      });
    }, 200);
  }

  setImage(file: File) {
    const that = this;
    new ImageCompressor(file, {
      maxWidth: 1000,
      maxHeight: 668,
      success(result) {
        that.newHorse.microchip = result;
      },
      error(e) {
        console.log(e.message);
        that.notificationsService.error(
          `${this.translation["uploadImage"]}`,
          `${this.translation["errorOccurred"]}`
        );
      },
    });
  }

  setNoteImages(file: File[]) {
    const that = this;

    this.newNote.src = file;
    this.isImagesChanged = true;

    setTimeout(() => {
      for (let i = 0; i < file.length; i++) {
        if (!(<any>file[i]).compressed) {
          new ImageCompressor((<any>file[i]).file, {
            maxWidth: 1000,
            maxHeight: 668,
            success(result) {
              (<any>file[i]).file = result;
              (<any>file[i]).compressed = true;
            },
            error(e) {
              // console.log(e.message);
              // that.notificationsService.error(
              //     'Upload Image',
              //     'Error occurred. Try again later'
              // );
            },
          });
        }
      }

      const imgs = $(".with_description .image-container .image");
      imgs.addClass("image-block");

      imgs.each((i) => {
        if ($(imgs[i]).find(".remove_on_remove_img").length === 0) {
          const a = `<div class="box-control remove_on_remove_img">
              <input type="text"
                     class="form-control input__field"
                     name="image_description_${i}"
                     autocomplete="off">
              <label class="input__label">
                <span>${this.translation["description"]}</span>
              </label>
            </div>`;
          $(a).appendTo(imgs[i]);
        }
      });
    }, 200);
  }

  public datePickerMask = {
    guide: true,
    showMask: true,
    mask: [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/],
  };

  formatDate(date) {
    if (date) {
      const arr = date.split("/");
      switch (environment.dateFormat) {
        case "MM/dd/yyyy":
          return arr[0] + "/" + arr[1] + "/" + arr[2];
        case "dd/MM/yyyy":
        default:
          return arr[1] + "/" + arr[0] + "/" + arr[2];
      }
    }
  }

  setNoteDate(date) {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.note_date = null;
    }
    this.newNote.date = this.datePipe
      .transform(date, "yyyy-MM-dd")
      .replace(/\s/g, "T");
    this.datePickerAddNote.currentDate = date;
    this.datePickerAddNote.currentDate_input = this.datePipe.transform(
      date,
      environment.dateFormat
    );
  }

  setNoteDateInput() {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.note_date = null;
    }
    if (
      new Date(
        this.formatDate(this.datePickerAddNote.currentDate_input)
      ).getTime() > this.datePickerAddNote.maxDate.getTime() ||
      new Date(
        this.formatDate(this.datePickerAddNote.currentDate_input)
      ).getTime() < this.datePickerAddNote.minDate.getTime() ||
      new Date(
        this.formatDate(this.datePickerAddNote.currentDate_input)
      ).toDateString() === "Invalid Date"
    ) {
      if (this.serverErrorValidate) {
        this.serverErrorValidate.note_date = "CORE.invalidDate";
      } else {
        this.serverErrorValidate = { note_date: "CORE.invalidDate" };
      }
      return;
    }
    this.datePickerAddNote.currentDate = new Date(
      this.formatDate(this.datePickerAddNote.currentDate_input)
    );
    this.newNote.date = this.datePipe.transform(
      this.formatDate(this.datePickerAddNote.currentDate_input),
      "yyyy-MM-dd"
    );
    this.datePickerAddNote.currentDate_input = this.datePipe.transform(
      new Date(),
      environment.dateFormat
    );
    this.datePickerAddNote.isActive = false;
  }

  setBirthDate(date) {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.birth = null;
    }
    this.newHorse.birth = this.datePipe.transform(date, "yyyy-MM-dd");
    this.datePicker.currentDate = date;
    this.datePicker.currentDate_input = this.datePipe.transform(
      date,
      environment.dateFormat
    );
  }

  setBirthDateInput() {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.birth = null;
    }
    if (
      new Date(this.formatDate(this.datePicker.currentDate_input)).getTime() >
      this.datePicker.maxDate.getTime() ||
      new Date(this.formatDate(this.datePicker.currentDate_input)).getTime() <
      this.datePicker.minDate.getTime() ||
      new Date(
        this.formatDate(this.datePicker.currentDate_input)
      ).toDateString() === "Invalid Date"
    ) {
      if (this.serverErrorValidate) {
        this.serverErrorValidate.birth = "CORE.invalidDate";
      } else {
        this.serverErrorValidate = { birth: "CORE.invalidDate" };
      }
      return;
    }
    this.newHorse.birth = this.datePipe.transform(
      this.formatDate(this.datePicker.currentDate_input),
      "yyyy-MM-dd"
    );
    this.datePicker.currentDate = new Date(
      this.formatDate(this.datePicker.currentDate_input)
    );
    this.datePicker.isActive = false;
  }

  getFarmSuggestion(variant: any) {
    this._searchStream.next(variant);
  }

  addTreatmentBulk() {
    this.clearUserInput(this.createTreatmentForm);

    var horseIds = this.selectedHorse || [];

    if (horseIds && horseIds.length > 0) {
      this.getService
        .getHorsesAdministers(horseIds)
        .then((result: User[]) => {
          if (result && result.length > 0) {
            this.administers = result
              .map((adm) => {
                return new Administer({
                  id: adm.id,
                  text: `${adm.name} ${adm.last_name}`,
                });
              })
              .concat(
                new Administer({
                  id: -1,
                  text: "Other",
                })
              );

            this.setDeaultAdministerValue();
          }
        })
        .catch((e) => (this.administers = []));
    }
  }
  addVaccinationBulk() { }
  addNoteBulk() { }

  initFarms() {
    if (this.appMemory.user && this.appMemory.user.farm) {
      this.farmsSelector.active = [
        {
          id: this.appMemory.user.organization.farms[0].id,
          text: this.appMemory.user.organization.farms[0].name,
        },
      ];
      this.farmsSelector.items = this.appMemory.user.organization.farms;
      /*[
                {
                    id: this.appMemory.user.organization.farm.id,
                    text: this.appMemory.user.organization.farm.name,
                },
            ];*/
      this.appMemory.user.farm.text = this.appMemory.user.farm.name;
      // this.farms = this.appMemory.user.organization.farms;
      this.newHorse.farm_id = this.farmsSelector.active[0].id;
    }
  }

  setCountryId(e) {
    this.updateFarm.country_id = e.id;
  }

  setRegion(e) {
    this.updateFarm.region = e.id;
  }

  navigateToHorse(id): void {
    setTimeout(() => {
      this.router.navigate(["/horses", id]);
    });
  }

  getTranslation() {
    this.translateService.get("OTHER.uploadImage").subscribe((word: string) => {
      this.translation["uploadImage"] = word;
    });
    this.translateService
      .get("OTHER.errorOccurred")
      .subscribe((word: string) => {
        this.translation["errorOccurred"] = word;
      });
    this.translateService
      .get("OTHER.addedSuccess")
      .subscribe((word: string) => {
        this.translation["addedSuccess"] = word;
      });
    this.translateService.get("YARDS.addYard").subscribe((word: string) => {
      this.translation["addYard"] = word;
    });
    this.translateService.get("CORE.yard").subscribe((word: string) => {
      this.translation["yard"] = word;
    });
    this.translateService.get("HORSES.vacc").subscribe((word: string) => {
      this.translation["vacc"] = word;
    });
    this.translateService.get("HORSES.addVacs").subscribe((word: string) => {
      this.translation["addVacs"] = word;
    });
    this.translateService.get("OTHER.uploadImage").subscribe((word: string) => {
      this.translation["uploadImage"] = word;
    });
    this.translateService.get("TREATS.addTreat").subscribe((word: string) => {
      this.translation["addTreat"] = word;
    });
    this.translateService
      .get("HORSES.addTreatment")
      .subscribe((word: string) => {
        this.translation["addTreatment"] = word;
      });
    this.translateService.get("TREATS.treatment").subscribe((word: string) => {
      this.translation["treatment"] = word;
    });
    this.translateService.get("HORSES.addHorse").subscribe((word: string) => {
      this.translation["addHorse"] = word;
    });
    this.translateService.get("HORSES.horse").subscribe((word: string) => {
      this.translation["horse"] = word;
    });
    this.translateService.get("HORSES.addNote").subscribe((word: string) => {
      this.translation["addNote"] = word;
    });
    this.translateService.get("HORSES.note").subscribe((word: string) => {
      this.translation["note"] = word;
    });
    this.translateService
      .get("HORSES.description")
      .subscribe((word: string) => {
        this.translation["description"] = word;
      });
  }

  generateNoteFields(selectedType?: string): NoteFormField[] {
    const [{ form = [] } = {}] = this.noteTypesList.filter(
      ({ type }) =>
        type === (this.hasSignNoteType ? NoteType.sign : selectedType)
    );

    return form;
  }

  processServerError(err?: any): string {
    const error = err || {};

    try {
      return !err._body
        ? err.message
        : Object.keys((err._body = JSON.parse(err._body)))
          .reduce((acc, key) => acc.concat(err._body[key]), [])
          .toString();
    } catch (e) {
      // tslint:disable-next-line:one-line
      return "";
    }
  }

  setTreatmentAdminister(e) {
    this.administer = [e];
    const administer = this.administers.filter(({ id }) => id == e.id).shift();
    this.newTreatment.administer = new TreatmentAdminister(
      (!!administer && {
        user_id: administer.id,
      }) ||
      {}
    );
  }

  setDeaultAdministerValue() {
    const administer = this.administers
      .filter(({ id }) => id == this.appMemory.user.id)
      .shift();
    this.administer = [administer];
    this.newTreatment.administer = new TreatmentAdminister(
      (!!administer && {
        user_id: administer.id,
      }) ||
      {}
    );
  }

  checkHorseIsBC2023Region() {
    if (this.farms && this.farms.length > 0) {
      const selectedFarm = this.farms.find(
        (farm) => farm.id == this.newHorse.farm_id
      );

      return selectedFarm && selectedFarm.region == usaRegionBC2023;
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/horses/horses.component.ts